import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/images/user-header.png';
var _hoisted_1 = {
  id: "mainPage"
};
var _hoisted_2 = {
  id: "rightMenu"
};
var _hoisted_3 = {
  "class": "menu-header flex-align"
};
var _hoisted_4 = {
  "class": "merchant-name"
};
var _hoisted_5 = {
  "class": "cur-list"
};
var _hoisted_6 = {
  "class": "cur-name flex-align"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  "class": "available-amount"
};
var _hoisted_9 = {
  key: 1,
  "class": "wait-amount"
};
var _hoisted_10 = {
  key: 1,
  "class": "holiday-notification"
};
var _hoisted_11 = {
  "class": "holiday-display"
};
var _hoisted_12 = {
  "class": "holiday-text"
};
var _hoisted_13 = {
  style: {
    "margin-left": "auto"
  }
};
var _hoisted_14 = {
  "class": "flex-align",
  style: {
    "margin-top": "8px"
  }
};
var _hoisted_15 = {
  "class": "flex-align",
  style: {
    "margin-top": "16px"
  }
};
var _hoisted_16 = {
  key: 0,
  "class": "login-time"
};
var _hoisted_17 = {
  "class": "help-menu-header"
};
var _hoisted_18 = {
  "class": "help-title"
};
var _hoisted_19 = {
  "class": "header-actions"
};
var _hoisted_20 = {
  key: 0,
  "class": "help-menu-content"
};
var _hoisted_21 = {
  "class": "help-item-text"
};
var _hoisted_22 = {
  "class": "help-item-title"
};
var _hoisted_23 = {
  "class": "help-item-desc"
};
var _hoisted_24 = {
  "class": "help-item-text"
};
var _hoisted_25 = {
  "class": "help-item-title"
};
var _hoisted_26 = {
  "class": "help-item-desc"
};
var _hoisted_27 = {
  key: 1,
  "class": "video-list-content"
};
var _hoisted_28 = {
  "class": "video-categories"
};
var _hoisted_29 = {
  "class": "category-section"
};
var _hoisted_30 = ["onClick"];
var _hoisted_31 = {
  "class": "video-icon"
};
var _hoisted_32 = {
  "class": "video-info-compact"
};
var _hoisted_33 = {
  "class": "video-title-compact"
};
var _hoisted_34 = {
  "class": "video-meta-compact"
};
var _hoisted_35 = {
  "class": "video-duration-compact"
};
var _hoisted_36 = {
  "class": "video-player"
};
var _hoisted_37 = ["src"];
var _hoisted_38 = {
  key: 1,
  "class": "video-placeholder"
};
var _hoisted_39 = {
  "class": "video-description"
};
var _hoisted_40 = {
  "class": "holiday-detail"
};
var _hoisted_41 = {
  "class": "holiday-date"
};
var _hoisted_42 = {
  "class": "holiday-content"
};
var _hoisted_43 = {
  style: {
    "white-space": "pre-line"
  }
};
var _hoisted_44 = {
  key: 0,
  "class": "holiday-currency"
};
var _hoisted_45 = {
  "class": "holiday-notice"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$currentVideo;
  var _component_left_menu = _resolveComponent("left-menu");
  var _component_a_tooltip = _resolveComponent("a-tooltip");
  var _component_question_circle_filled = _resolveComponent("question-circle-filled");
  var _component_a_button = _resolveComponent("a-button");
  var _component_notification_outlined = _resolveComponent("notification-outlined");
  var _component_calendar_outlined = _resolveComponent("calendar-outlined");
  var _component_a_menu_item = _resolveComponent("a-menu-item");
  var _component_a_menu = _resolveComponent("a-menu");
  var _component_a_dropdown = _resolveComponent("a-dropdown");
  var _component_global_outlined = _resolveComponent("global-outlined");
  var _component_language_selector = _resolveComponent("language-selector");
  var _component_router_view = _resolveComponent("router-view");
  var _component_question_circle_outlined = _resolveComponent("question-circle-outlined");
  var _component_customer_service_outlined = _resolveComponent("customer-service-outlined");
  var _component_arrow_left_outlined = _resolveComponent("arrow-left-outlined");
  var _component_close_outlined = _resolveComponent("close-outlined");
  var _component_book_outlined = _resolveComponent("book-outlined");
  var _component_play_circle_outlined = _resolveComponent("play-circle-outlined");
  var _component_right_outlined = _resolveComponent("right-outlined");
  var _component_video_camera_outlined = _resolveComponent("video-camera-outlined");
  var _component_a_modal = _resolveComponent("a-modal");
  var _component_exclamation_circle_outlined = _resolveComponent("exclamation-circle-outlined");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_left_menu), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_tooltip, {
    title: _ctx.$store.getters.getUserInfo.merchantName
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('pages_main_053')) + _toDisplayString(_ctx.$store.getters.getUserInfo.merchantName), 1)];
    }),
    _: 1
  }, 8, ["title"]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.curList, function (cur, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      "class": "cur"
    }, [index === 3 ? (_openBlock(), _createBlock(_component_a_tooltip, {
      key: 0,
      placement: "bottom"
    }, {
      title: _withCtx(function () {
        return [_createElementVNode("div", null, _toDisplayString(_ctx.$t('pages_main_025')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('pages_main_026')), 1)];
      }),
      "default": _withCtx(function () {
        return [_createVNode(_component_question_circle_filled, {
          "class": "ic-tip"
        })];
      }),
      _: 1
    })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
      src: _ctx.getCountryLogo(cur.curType)
    }, null, 8, _hoisted_7), _createElementVNode("span", null, _toDisplayString(cur.curType), 1)]), _createElementVNode("div", _hoisted_8, _toDisplayString(cur.totalAmount ? _ctx.parseMoney(cur.totalAmount, cur.curType) : '0.00'), 1), cur.freezeAmount !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('pages_main_024')) + _toDisplayString(_ctx.parseMoney(cur.freezeAmount, cur.curType)), 1)])) : _createCommentVNode("", true)]);
  }), 128))]), _ctx.$store.getters.curList.length !== 0 ? (_openBlock(), _createBlock(_component_a_button, {
    key: 0,
    shape: "round",
    type: "primary",
    style: {
      "font-size": "13px",
      "margin-left": "32px"
    },
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$router.push('/wallet/index');
    })
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t('pages_main_027')), 1)];
    }),
    _: 1
  })) : _createCommentVNode("", true), _ctx.holidayNotifications.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_notification_outlined, {
    "class": "notification-icon"
  }), _createElementVNode("div", _hoisted_11, [_ctx.currentHolidayItem ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": _normalizeClass(["holiday-item-fade", {
      'holiday-item-hidden': !_ctx.holidayVisible
    }]),
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.showHolidayDetail(_ctx.currentHolidayItem);
    })
  }, [_createVNode(_component_calendar_outlined, {
    "class": "holiday-icon"
  }), _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.currentHolidayItem.duration + ' ' + _ctx.currentHolidayItem.title), 1)], 2)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[14] || (_cache[14] = _createElementVNode("img", {
    "class": "user-header",
    src: _imports_0
  }, null, -1)), _createVNode(_component_a_dropdown, null, {
    overlay: _withCtx(function () {
      return [_createVNode(_component_a_menu, null, {
        "default": _withCtx(function () {
          return [_createVNode(_component_a_menu_item, null, {
            "default": _withCtx(function () {
              return [_createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = function ($event) {
                  return _ctx.$router.push('/user/account_materials');
                })
              }, _toDisplayString(_ctx.$t('pages_router_031')), 1)];
            }),
            _: 1
          }), _createVNode(_component_a_menu_item, null, {
            "default": _withCtx(function () {
              return [_createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = function ($event) {
                  return _ctx.$router.push('/user/user_manage');
                })
              }, _toDisplayString(_ctx.$t('pages_router_032')), 1)];
            }),
            _: 1
          }), _createVNode(_component_a_menu_item, null, {
            "default": _withCtx(function () {
              return [_createElementVNode("a", {
                onClick: _cache[5] || (_cache[5] = function ($event) {
                  return _ctx.$router.push('/user/account_security');
                })
              }, _toDisplayString(_ctx.$t('pages_router_033')), 1)];
            }),
            _: 1
          }), _createVNode(_component_a_menu_item, null, {
            "default": _withCtx(function () {
              return [_createElementVNode("a", {
                onClick: _cache[6] || (_cache[6] = function () {
                  return _ctx.signOut && _ctx.signOut.apply(_ctx, arguments);
                })
              }, _toDisplayString(_ctx.$t('pages_main_028')), 1)];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    "default": _withCtx(function () {
      return [_createElementVNode("a", {
        "class": "merchant-email",
        onClick: _cache[2] || (_cache[2] = _withModifiers(function () {}, ["prevent"]))
      }, _toDisplayString(_ctx.$store.getters.getUserInfo.email), 1)];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_15, [_createVNode(_component_global_outlined, {
    "class": "ic-global",
    style: {
      "margin-right": "4px",
      "font-size": "16px"
    }
  }), _createVNode(_component_language_selector)])]), _ctx.loginTime ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('pages_main_057', [_ctx.loginTime])), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", {
    id: "menuContent",
    "class": "menu-content",
    style: _normalizeStyle({
      width: _ctx.clientWidth < 800 ? '1280px' : 'auto'
    })
  }, [_createVNode(_component_router_view)], 4)]), _createElementVNode("div", {
    "class": "floating-help-btn",
    onClick: _cache[7] || (_cache[7] = function () {
      return _ctx.toggleHelpMenu && _ctx.toggleHelpMenu.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_question_circle_outlined, {
    "class": "help-icon"
  })]), _createElementVNode("div", {
    "class": _normalizeClass(["help-menu-overlay", {
      'active': _ctx.helpMenuVisible
    }]),
    onClick: _cache[11] || (_cache[11] = function () {
      return _ctx.closeHelpMenu && _ctx.closeHelpMenu.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", {
    "class": _normalizeClass(["help-menu", {
      'active': _ctx.helpMenuVisible
    }]),
    onClick: _cache[10] || (_cache[10] = _withModifiers(function () {}, ["stop"]))
  }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_customer_service_outlined), _createTextVNode(" " + _toDisplayString(_ctx.showVideoList ? _ctx.$t('pages_main_help_video') || '视频帮助' : _ctx.$t('pages_main_help_title') || '帮助中心'), 1)]), _createElementVNode("div", _hoisted_19, [_ctx.showVideoList ? (_openBlock(), _createBlock(_component_arrow_left_outlined, {
    key: 0,
    "class": "back-btn",
    onClick: _ctx.backToMainMenu
  }, null, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_close_outlined, {
    "class": "close-btn",
    onClick: _ctx.closeHelpMenu
  }, null, 8, ["onClick"])])]), !_ctx.showVideoList ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", {
    "class": "help-item",
    onClick: _cache[8] || (_cache[8] = function () {
      return _ctx.openUserGuide && _ctx.openUserGuide.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_book_outlined, {
    "class": "help-item-icon"
  }), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('pages_main_help_guide') || '使用指南'), 1), _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('pages_main_help_guide_desc') || '了解平台功能和操作流程'), 1)])]), _createElementVNode("div", {
    "class": "help-item",
    onClick: _cache[9] || (_cache[9] = function () {
      return _ctx.openVideoHelp && _ctx.openVideoHelp.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_play_circle_outlined, {
    "class": "help-item-icon"
  }), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('pages_main_help_video') || '视频帮助'), 1), _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('pages_main_help_video_desc') || '观看操作演示视频'), 1)]), _createVNode(_component_right_outlined, {
    "class": "arrow-icon"
  })])])) : (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList.filter(function (v) {
    return v.category === 'basic';
  }), function (video) {
    return _openBlock(), _createElementBlock("div", {
      key: video.id,
      "class": "video-item-compact",
      onClick: function onClick($event) {
        return _ctx.playVideo(video);
      }
    }, [_createElementVNode("div", _hoisted_31, [_createVNode(_component_play_circle_outlined)]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t(video.title)), 1), _createElementVNode("div", _hoisted_34, [_createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$i18n.locale === 'zh' ? video.cnDuration : video.enDuration), 1)])])], 8, _hoisted_30);
  }), 128))])])]))], 2)], 2), _createVNode(_component_a_modal, {
    visible: _ctx.videoModalVisible,
    "onUpdate:visible": _cache[12] || (_cache[12] = function ($event) {
      return _ctx.videoModalVisible = $event;
    }),
    title: (_ctx$currentVideo = _ctx.currentVideo) !== null && _ctx$currentVideo !== void 0 && _ctx$currentVideo.title ? _ctx.$t(_ctx.currentVideo.title) : '',
    width: "800px",
    footer: null,
    centered: "",
    "z-index": 2000,
    onCancel: _ctx.closeVideoModal
  }, {
    "default": _withCtx(function () {
      var _ctx$currentVideo2, _ctx$currentVideo3, _ctx$currentVideo4, _ctx$currentVideo5, _ctx$currentVideo6;
      return [_createElementVNode("div", _hoisted_36, [(_ctx$currentVideo2 = _ctx.currentVideo) !== null && _ctx$currentVideo2 !== void 0 && _ctx$currentVideo2.enVideoUrl || (_ctx$currentVideo3 = _ctx.currentVideo) !== null && _ctx$currentVideo3 !== void 0 && _ctx$currentVideo3.cnVideoUrl ? (_openBlock(), _createElementBlock("video", {
        key: 0,
        src: _ctx.$i18n.locale === 'zh' ? (_ctx$currentVideo4 = _ctx.currentVideo) === null || _ctx$currentVideo4 === void 0 ? void 0 : _ctx$currentVideo4.cnVideoUrl : (_ctx$currentVideo5 = _ctx.currentVideo) === null || _ctx$currentVideo5 === void 0 ? void 0 : _ctx$currentVideo5.enVideoUrl,
        controls: "",
        autoplay: "",
        width: "100%",
        height: "400"
      }, _toDisplayString(_ctx.$t('pages_help_video_unsupported')), 9, _hoisted_37)) : (_openBlock(), _createElementBlock("div", _hoisted_38, [_createVNode(_component_video_camera_outlined), _createElementVNode("p", null, _toDisplayString(_ctx.$t('pages_help_video_loading')), 1)]))]), _createElementVNode("div", _hoisted_39, [_createElementVNode("h4", null, _toDisplayString(_ctx.$t('pages_help_video_description')), 1), _createElementVNode("p", null, _toDisplayString((_ctx$currentVideo6 = _ctx.currentVideo) !== null && _ctx$currentVideo6 !== void 0 && _ctx$currentVideo6.description ? _ctx.$t(_ctx.currentVideo.description) : ''), 1)])];
    }),
    _: 1
  }, 8, ["visible", "title", "onCancel"]), _createVNode(_component_a_modal, {
    visible: _ctx.holidayDetailVisible,
    "onUpdate:visible": _cache[13] || (_cache[13] = function ($event) {
      return _ctx.holidayDetailVisible = $event;
    }),
    title: _ctx.$t('pages_main_holiday_detail_title') || '节假日详情',
    width: "600px",
    footer: null,
    centered: "",
    "z-index": 2000
  }, {
    "default": _withCtx(function () {
      var _ctx$selectedHoliday, _ctx$selectedHoliday2, _ctx$selectedHoliday3, _ctx$selectedHoliday4;
      return [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createVNode(_component_calendar_outlined), _createElementVNode("span", null, _toDisplayString((_ctx$selectedHoliday = _ctx.selectedHoliday) === null || _ctx$selectedHoliday === void 0 ? void 0 : _ctx$selectedHoliday.duration), 1)]), _createElementVNode("div", _hoisted_42, [_createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.formatHolidayContent((_ctx$selectedHoliday2 = _ctx.selectedHoliday) === null || _ctx$selectedHoliday2 === void 0 ? void 0 : _ctx$selectedHoliday2.content)), 1)]), (_ctx$selectedHoliday3 = _ctx.selectedHoliday) !== null && _ctx$selectedHoliday3 !== void 0 && _ctx$selectedHoliday3.currency ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('pages_main_holiday_detail_currency')) + ": " + _toDisplayString((_ctx$selectedHoliday4 = _ctx.selectedHoliday) === null || _ctx$selectedHoliday4 === void 0 ? void 0 : _ctx$selectedHoliday4.currency), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_45, [_createVNode(_component_exclamation_circle_outlined), _createElementVNode("span", null, _toDisplayString(_ctx.$t('pages_main_holiday_detail_notice')), 1)])])];
    }),
    _: 1
  }, 8, ["visible", "title"])]);
}